import React, { useMemo } from 'react';
import cn from 'classnames';
import PrismicImage from '@components/cms/PrismicImage';
import { setPromoDetailsCookie } from '@utils/gtm';

import styles from './BannerImage.module.scss';

interface BannerImageProps {
  image: {
    url: string;
    alt: string;
    dimensions: {
      width: number;
      height: number;
    };
  };
  classNames?: string | string[];
  link?: string;
  trackPromos?: boolean;
  pageType?: string;
  sliceIndex?: number;
}

const BannerImage = ({
  image,
  classNames,
  link,
  trackPromos,
  pageType,
  sliceIndex,
}: BannerImageProps) => {
  const rootClassNames = cn(styles.bannerImageRoot, classNames);

  const promoDetails = useMemo(
    () => ({
      id: image.alt,
      name: image.alt,
      type: 'image',
      url: link,
      position: `${pageType}-${sliceIndex}-HeroImage`,
    }),
    [image.alt, link, pageType, sliceIndex]
  );

  return (
    <div className={rootClassNames}>
      <div className={styles.bannerImage}>
        {!!link ? (
          <a
            href={link}
            onClick={
              trackPromos
                ? () => setPromoDetailsCookie(promoDetails)
                : undefined
            }
          >
            <PrismicImage
              src={image?.url}
              alt={image?.alt}
              layout="responsive"
              priority
              quality={85}
              width={image?.dimensions?.width}
              height={image?.dimensions.height}
            />
          </a>
        ) : (
          <PrismicImage
            src={image?.url}
            alt={image?.alt}
            layout="responsive"
            priority
            quality={85}
            width={image?.dimensions?.width}
            height={image?.dimensions.height}
          />
        )}
      </div>
    </div>
  );
};

export default BannerImage;
